export default "__VITE_ASSET__yuwhvCdi__"